<template>
    <div class="swiper">
        <img src="/src/assets/img/common/slider-arrow-prev.png" alt="＜" class="slide-arrow prev-arrow">
        <div class="swiper-wrapper">
            <div :data-cy="`slide-item-${i}`" class="swiper-slide" v-for="(gravure_item,i) in gravure_list">
                <a :href="route(route_list, 'site.item.detail.gravure', {
                    item_detail_url: gravure_item.url
                })">
                    <div class="c-slider-normal__img">
                        <webp-picture :webp="gravure_item.thumbnail_webp" class="inherit">
                            <img :data-cy="`slide-img-${i}`" :src="gravure_item.thumbnail" :alt="gravure_item.title" loading="lazy">
                        </webp-picture>
                    </div>
                    <div class="label-container">
                        <div class="c-label is-new" v-if="gravure_item.is_new">New</div>
                        <div class="c-label is-photos">写真集</div>
                        <div class="c-label is-limited" v-if="gravure_item.extra">限定特典付</div>
                    </div>
                    <div class="c-book-block__wrapper">
                        <p class="c-booktitle u-text-ellipsis has-2-lines">{{ gravure_item.title }}</p>
                    </div>
                    <div class="c-book-block__wrapper">
                        <p class="c-bookname u-text-ellipsis has-2-lines">{{ gravure_item.model_name }}</p>
                    </div>
                </a>
                <div v-if="gravure_item.BROWSER_VIEW_PARAM" class="c-round-btn is-positive is-transparent">
                    <a class="is-blue" :href="route(route_list, 'site.item.sample', {
                        item_detail_url: gravure_item.url
                    })" target="_blank">立ち読み</a>
                </div>
            </div>
        </div>
        <img src="/src/assets/img/common/slider-arrow-next.png" alt="＞" class="slide-arrow next-arrow">
    </div>
</template>

<script>
import routeMixin from '../../mixins/route.js';
export default {
    props: [
        'gravure_list',
        'route_list',
        'utm_content'
    ],
    mixins: [routeMixin],
    data() {
        return {
        }
    },
}
</script>

<style scoped>
.swiper {
    width: 100%;
}

.label-container {
    min-height: 42px;
    display: flex;
    flex-wrap: wrap;
}

.c-booktitle {
    margin: 0;
    color: var(--gj-text-color-light);
    text-align: start;
    word-break: break-all;
}

.c-bookname {
    margin: 0;
    text-align: start;
    align-items: center;
    line-height: 18.2px;
}

.c-book-block__wrapper {
    display: flex;
    align-items: center;

    &:has(.c-booktitle) {
        min-height: 32px;
    }

    &:has(.c-bookname) {
        min-height: 37px;
        margin-bottom: 8px;
    }
}</style>
